var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmerald(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 42,
    viewBox: "0 0 24 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5008 30.7479L17.5008 11.2516C16.4716 10.2224 15.8944 9.64519 14.8652 8.61597L9.80164 8.61597C8.77241 9.64519 8.19524 10.2224 7.16602 11.2516L7.16601 30.7481C8.19524 31.7774 8.77241 32.3545 9.80164 33.3838L14.8652 33.3838C15.8944 32.3543 16.4716 31.7771 17.5008 30.7479Z",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.2659 36.128L23.2659 5.87176C21.3633 3.96921 20.2967 2.90255 18.3941 1L6.27264 1C4.37009 2.90255 3.30343 3.96921 1.40088 5.87176L1.40088 36.128C3.30343 38.0305 4.37009 39.0972 6.27264 40.9997L18.3941 40.9997C20.2967 39.0972 21.3633 38.0305 23.2659 36.128Z",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.855 32.826L19.855 9.17388C18.4716 7.79055 17.696 7.01492 16.3127 5.63159L8.35453 5.63159C6.97121 7.01492 6.19558 7.79055 4.81226 9.17388L4.81225 32.826C6.19558 34.2093 6.97121 34.985 8.35453 36.3683L16.3127 36.3683C17.696 34.9847 18.4716 34.2093 19.855 32.826Z",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.40088 5.87183L7.16597 11.2518",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.27271 1L9.80166 8.6161",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.3942 1L14.8652 8.6161",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.2658 5.87183L17.5007 11.2518",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M23.2658 36.128L17.5007 30.748",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M18.3942 40.9999L14.8652 33.3838",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M6.2727 40.9999L9.80166 33.3838",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M1.40088 36.128L7.16597 30.748",
    stroke: "#0E1831",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmerald);
export default __webpack_public_path__ + "static/media/emerald.3e862ca814e0a2eee452e86e2caa79b5.svg";
export { ForwardRef as ReactComponent };